var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import SecondaryNavButton from "../../../../UI/SecondaryNav/SecondaryNavButton";
import SecondaryNavLayout from "../../../../Layout/SecondaryNavLayout";
import ContentLayout from "../../../../Layout/ContentLayout";
import RuleSetForm, { getRuleSetRequest, } from "../../../../Presentational/RuleSet/RuleSetForm";
import { getRuleSetDetailPath } from "../AdminDuplicateDetectionRoutes";
import useService from "../../../../Hooks/useService";
import RuleSetService from "../../../../../Services/RuleSet.service";
import ServiceResult from "../../../../UI/ServiceResult/ServiceResult";
import { BasicFormFormat } from "../../../../UI/FormFormat/FormFormat";
import DuplicatePersonService from "../../../../../Services/DuplicatePerson.service";
import { AlertInfo } from "../../../../UI/StandardAlerts/StandardAlerts";
const RuleSetEdit = () => {
    const saveButtonRef = useRef(null);
    const [ruleSetState, loadRuleSet] = useService(RuleSetService.get);
    const params = useParams();
    const ruleSetId = parseInt(params.id, 10);
    React.useEffect(() => {
        loadRuleSet(ruleSetId);
    }, [ruleSetId, loadRuleSet]);
    const [isViewRefreshingState, loadIsViewRefreshing] = useService(DuplicatePersonService.isDetectedDuplicateViewRefreshing);
    React.useEffect(() => {
        loadIsViewRefreshing();
    }, [loadIsViewRefreshing]);
    const submit = (state) => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-expect-error - TS2345 - Argument of type 'RuleSetRequest' is not assignable to parameter of type 'RuleSetUpdateRequest'.
        yield RuleSetService.update(getRuleSetRequest(state)).then((response) => {
            if (response) {
                window.location.href = getRuleSetDetailPath(response.id);
            }
        });
    });
    return (_jsx(SecondaryNavLayout, { dontAddSpacer: true, nav: _jsxs("div", { className: "d-flex", children: [" ", _jsx(SecondaryNavButton, { icon: "save", label: "Save", title: "Save", onClick: () => {
                        var _a;
                        (_a = saveButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    } }), " ", _jsx(Link, { to: getRuleSetDetailPath(ruleSetId), children: _jsx(SecondaryNavButton, { icon: "times", label: "Cancel", title: "Cancel" }) }, "Cancel")] }), children: _jsxs(ContentLayout, { className: "mt-3", whiteBackground: true, children: [isViewRefreshingState.data === true && (_jsx(AlertInfo, { message: "New duplicates are currently being detected. Edits to Rule Sets will not take effect until this process completes." })), _jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsx("h1", { className: "title", children: "Edit Rule Set" }) }) }), _jsx(ServiceResult, { state: ruleSetState, children: (ruleSet) => (_jsx(BasicFormFormat, { hideButtons: true, saveButtonRef: saveButtonRef, handleSubmit: submit, defaultValue: {
                            id: ruleSet.id,
                            name: ruleSet.name,
                            active: ruleSet.active,
                            firstName: ruleSet.firstName,
                            lastName: ruleSet.lastName,
                            personalEmailAddress: ruleSet.personalEmailAddress,
                            birthDate: ruleSet.birthDate,
                            addressLine1: ruleSet.addressLine1,
                            city: ruleSet.city,
                            state: ruleSet.state,
                            zipCode: ruleSet.zipCode,
                        }, errorMessagePosition: "top", children: _jsx(RuleSetForm, {}) })) })] }) }));
};
export default RuleSetEdit;
